//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/DisplayableObject.js";
import "../no/ugmath.js";
let d=[[],[[["num_supports"],"CreateSupports",{R_:{supports:"Mfg.AM.Support[]"}},0,0],[["num_supports"],"GetSupports",{R_:{supports:"Mfg.AM.Support[]"}},0,0],[["support"],"RemoveSupport",{},1,0],[[],"RemoveAllSupports",{},0,0],[["numObjects"],"GetGeometry",{R_:{geometry:"DisplayableObject[]"}},0,0],[[],"CreateSupportBuilder",{R_:{tagBuilder:"Mfg.AM.SupportBuilder"}},0,0],[["tagProfile"],"SetDefaultProfile",{},1,1],[["tagSupportProfile"],"SetSupportProfile",{},1,0],[["ptMin","ptMax"],"GetDimensions",{},0,0],[["buildStrategyNames","buildStrategyValues"],"SetBuildStrategyValues",{},2,0],[["count","buildStrategyNames","buildStrategyValues"],"GetBuildStrategyValues",{},0,0],[[],"ClearBuildStrategyValues",{},0,0],[["supportsToReorder","anchor","reorderBefore"],"ReorderSupports",{},3,0],[[],"GetWaveLinkFeature",{R_:{waveLinkFrec:"Features.Feature"}},0,0]],[]];
SPLM.Mfg.AM.PartRegion = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.PartRegion";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;